export const AclChangeTemplates: Record<string, (name: string, permission_label: string) => string> = {
  granted: (name, permission_label) =>
    `granted <span class="fw-600">${permission_label}</span> permissions to folder <span class="fw-600">${name}</span> to: `,
  removed: (name, permission_label) =>
    `unshared folder <span class="fw-600">${name}</span> with <span class="fw-600">${permission_label}</span> permissions from `,
  edit_only: (name) =>
    `granted <span class="fw-600">Edit</span> permissions for <span class="fw-600">${name}</span> to `,
  read_only: (name) =>
    `granted <span class="fw-600">Read Only</span> permissions to <span class="fw-600">${name}</span> to `,
  view_only: (name) =>
    `granted <span class="fw-600">View Only</span> permissions to <span class="fw-600">${name}</span> to `,
};

export const ChangeDisplayNameTemplate = (user_email: string, old_name: string, new_name: string) => `has changed the display name for <span class="fw-600">${user_email}</span> from <span class="fw-600">${old_name}</span> to <span class="fw-600">${new_name}</span>`;
